import React, {useEffect, useRef, useState} from 'react'
import TreeView, {flattenTree} from 'react-accessible-treeview'
import {Button, Card, Col, Collapse, Form, Modal, Row, Table} from 'react-bootstrap'
import {
  ExportEngineeringService,
  GetBrowseTagService,
  GetTagLogService,
} from '../../service/tag.service'
import {
  GetTagTypeByChildService,
  GetTagTypeByDisciplineService,
} from '../../service/tag-type.service'
import {FormikProps, useFormik} from 'formik'
import {GetMyInfoService} from '../../service/company.service'
import Multiselect from '../../components/MultiSelect'
import {ColumnDef} from '@tanstack/react-table'
import TableData from '../../components/Table'
import {DEFAULT_META, DEFAULT_PAGE_OPTION} from '../../constants/page-option/page-option'
import {IPageMeta} from '../../interface/paging/meta-paging'
import {IPageOption} from '../../interface/paging/paging'
import Select from '../../components/Select'
import {IUser} from '../../interface/user/user'
import {IPlant} from '../../interface/plant/plant'
import {GetPlantByCompanyService} from '../../service/plant.service/plant.service'
import {useUserSelector} from '../../store/user'
import {GetDisciplineByPlantService} from '../../service/discipline.service/discipline'
import {IDiscipline} from '../../interface/discipline/discipline'
import {IAttribute} from '../../interface/attribute'
import {GetAttributeByPlantService} from '../../service/attribute.service'
import {ITagType} from '../../interface/tag-type'
import Swal from 'sweetalert2'
import {DEFAULT_WARNING_MODAL} from '../../constants/errors/error-model'
import TextField from '../../components/TextField'
import {formatDate} from '../../helpers'
import ModalLog from '../../components/ModalLog'
import ButtonComp from '../../components/Button'
import exportFile from '../../modules/report/ExportFile'
interface ITagFilter {
  companyId: string
  plantIds: string[]
  plantId: string
  disciplineId: string
  attributeGroupIds: string[]
  tagTypeIds: string[]
  isActive: boolean | undefined | string
  tagDescription: string
  tagNumber: string
  attributeValue: string
}
const initialFilterValue: ITagFilter = {
  companyId: '',
  plantIds: [],
  plantId: '',
  disciplineId: '',
  attributeGroupIds: [],
  tagTypeIds: [],
  isActive: undefined,
  tagDescription: '',
  tagNumber: '',
  attributeValue: '',
}
const BrowseTagPage = () => {
  const {user, isUser, myCompany} = useUserSelector()

  const [modalShow, setModalShow] = useState(false)
  const [modalAttribute, setModalAttribute] = useState<any[]>([])
  const [tagSelected, setTagSelected] = useState<any>({})
  const [defaultExpandedIds, setDefaultExpandedIds] = useState<string[]>([])
  const [defaultSelectedIds, setDefaultSelectedIds] = useState<string[]>([])
  const [columns, setColumns] = useState<ColumnDef<any>[]>([])
  const [browseTag, setBrowseTag] = useState<any>([])
  const [test, setTest] = useState<any>()
  const [plants, setPlants] = useState<IPlant[]>()
  const [disciplines, setDisciplines] = useState<IDiscipline[]>()
  const [attribute, setAttribute] = useState<IAttribute[]>()
  const [tagTypesList, setTagTypesList] = useState<ITagType[]>()
  const [tags, setTags] = useState<any[]>()
  const [meta, setMeta] = useState<IPageMeta>(DEFAULT_META)
  const [pageOption, setPageOption] = useState<IPageOption>({
    limit: -1,
    page: 1,
  })
  const [modalLogShow, setModalLogShow] = useState(false)
  const [logId, setLogId] = useState<string>('')

  const formikFilter: FormikProps<ITagFilter> = useFormik({
    initialValues: initialFilterValue,
    onSubmit: async (values, {setSubmitting}) => {
      // if (!values.companyId) {
      //   await Swal.fire(DEFAULT_WARNING_MODAL('Company is required!'))
      //   setSubmitting(false)
      //   return
      // }
      await getBrowseTag()
      setSubmitting(false)
    },
  })

  useEffect(() => {
    if (!user) return
    // if (!isUser) getBrowseTag()
  }, [user])

  const initUser = () => {
    if (isUser && myCompany) {
      formikFilter.setFieldValue('companyId', myCompany.company.id)
    }
  }
  useEffect(() => {
    initUser()
  }, [isUser])

  useEffect(() => {
    formikFilter.values.plantIds = []
    formikFilter.values.plantId = ''
    formikFilter.values.disciplineId = ''
    formikFilter.setFieldValue('tagTypeIds', [])
    formikFilter.setFieldValue('attributeGroupIds', [])
    if (!formikFilter.values.companyId) {
      setPlants([])
      return
    }
    if (isUser) {
      formikFilter.submitForm()
      return
    }

    getPlants(formikFilter.values.companyId as string).then((res) => {
      setPlants(res)
    })
  }, [formikFilter?.values?.companyId])

  useEffect(() => {
    formikFilter.setFieldValue('disciplineId', '')
    formikFilter.setFieldValue('attributeGroupIds', [])
    if (!formikFilter.values.plantId) {
      setDisciplines([])
      setAttribute([])
      return
    }
    getDisciplinesByPlantId(formikFilter.values.plantId)
    getAttributeByPlantId(formikFilter.values.plantId)
  }, [formikFilter.values.plantId])

  useEffect(() => {
    formikFilter.setFieldValue('tagTypeIds', [])
    setTagTypesList([])

    if (!formikFilter.values.disciplineId) return
    getTagTypeByDisciplineId(formikFilter.values.disciplineId)
  }, [formikFilter.values.disciplineId])

  const getPlants = async (id: string) => {
    const getPlantService = new GetPlantByCompanyService()
    const _plants = await getPlantService.request(id)
    return _plants
  }
  const getDisciplinesByPlantId = async (plantId: string) => {
    const getDisciplineService = new GetDisciplineByPlantService()
    const _disciplines = await getDisciplineService.request(plantId)
    setDisciplines(_disciplines.data)
  }
  const getAttributeByPlantId = async (plantId: string) => {
    const getDisciplineService = new GetAttributeByPlantService()
    const _attribute = await getDisciplineService.request(plantId)
    setAttribute(_attribute)
  }
  const getTagTypeByDisciplineId = async (disciplineId: string) => {
    const getDisciplineService = new GetTagTypeByDisciplineService()
    const _tagType = await getDisciplineService.request(disciplineId)
    setTagTypesList(_tagType.data)
  }
  const getBrowseTag = async () => {
    setTags(undefined)
    setTest(undefined)
    let params
    // if (formikFilter.values.companyId && formikFilter.values.plantIds.length === 0) {
    //   let temp = user?.companies?.find((el) => {
    //     if (el.company.id === formikFilter.values.companyId) {
    //       return el
    //     }
    //   }) as any

    //   if (temp?.plants?.length === 0) {
    //     setBrowseTag([])
    //     setTest(null)
    //     return
    //   } else {
    //     params = {
    //       ...formikFilter.values,
    //       plantIds: temp?.plants,
    //     }
    //   }
    // } else {
    //   params = {
    //     ...formikFilter.values,
    //   }
    // }
    console.log('formikFilter.values', formikFilter.values.plantId)

    params = {
      companyId: formikFilter.values.companyId || undefined,
      plantIds: formikFilter.values.plantId ? [formikFilter.values.plantId] : undefined,
      disciplineIds: formikFilter.values.disciplineId
        ? [formikFilter.values.disciplineId]
        : undefined,
      attributeGroupIds:
        formikFilter.values.attributeGroupIds.length > 0
          ? formikFilter.values.attributeGroupIds.map((el: any) => {
              return el.id
            })
          : undefined,
      tagTypeIds:
        formikFilter.values.tagTypeIds.length > 0
          ? formikFilter.values.tagTypeIds.map((el: any) => {
              return el.id
            })
          : undefined,
      tagDescription: formikFilter.values.tagDescription || undefined,
      tagNumber: formikFilter.values.tagNumber || undefined,
      isActive: true,
      attributeValue: formikFilter.values.attributeValue || undefined,
      // getAll: true,
    }
    console.log('params', params)
    // if (!params.companyId) params.companyId = undefined
    const getBrowseTagService = new GetBrowseTagService()
    const _browseTag = await getBrowseTagService.request(params)

    const tempTest = [..._browseTag]
    tempTest.forEach((obj1) => {
      if (obj1.hasOwnProperty('disciplines')) {
        obj1['children'] = obj1['disciplines']
        delete obj1['disciplines']
      }
      obj1.children.forEach((obj2) => {
        if (obj2.hasOwnProperty('tagTypes')) {
          obj2['children'] = obj2['tagTypes']
          delete obj2['tagTypes']
        }
        obj2.children.forEach((obj3) => {
          if (obj3.hasOwnProperty('tags')) {
            // obj3['children'] = obj3['tags']
            obj3['metadata'] = {...obj3, treeState: [obj1.id, obj2.id, obj3.id]}
            // delete obj3['tags']
          }
        })
      })
    })
    console.log('tempTest', tempTest)
    const qqq = {
      name: 'browse tag',
      children: [...tempTest],
    }
    setBrowseTag([...tempTest])
    setTest(flattenTree(qqq))

    // set tag type แรก
    const _dataTable = tempTest[0]?.children[0]?.children[0]?.tags || []
    onSetTable(_dataTable)
    if (_dataTable.length > 0) {
      setDefaultExpandedIds([
        tempTest[0].id,
        tempTest[0]?.children[0].id,
        tempTest[0]?.children[0]?.children[0].id,
      ])
      setDefaultSelectedIds([tempTest[0]?.children[0]?.children[0].id])
    }
  }
  const ontest = async (e) => {
    if (e.element?.metadata?.tags.length > 0) {
      onSetTable(e.element.metadata.tags)
    } else {
      setColumns([])
    }
    if (!e.element?.metadata?.hasChildren) return
    if (e.element.children?.length != 0) return

    const getTagTypeByChild = new GetTagTypeByChildService()
    const _tagType = await getTagTypeByChild.request(e.element?.metadata?.id)
    _tagType.data.forEach((obj) => {
      if (obj.hasOwnProperty('tags')) {
        obj['children'] = obj['tags']
        obj['metadata'] = {
          ...obj,
          treeState: [...e.element.metadata.treeState, obj.id],
        }
        // delete obj['tags']
      }
    })

    let text = ``
    e.element.metadata.treeState.forEach((id) => {
      // เข้าครั้งแรกเช็คจาก loop แรก
      if (!text) {
        for (let i in browseTag) {
          if (browseTag[i].id === id) {
            text = `[${i}]['children']`
            break
          }
        }
      } else {
        for (let i in getValueByKeyString(browseTag, text)) {
          if (getValueByKeyString(browseTag, text)[i].id === id) {
            text += `[${i}]['children']`
            break
          }
        }
      }
    })
    getValueByKeyString(browseTag, text.substring(0, text.length - 12)).children = _tagType.data

    // for (let i in getValueByKeyString(browseTag, text)) {
    //   if (getValueByKeyString(browseTag, text)[i].id === e.treeState.tabbableId) {
    //     getValueByKeyString(browseTag, text)[i].children = _tagType.data
    //     break
    //   }
    // }

    const tempTest = [...browseTag]
    const qqq = {
      name: 'browse tag',
      children: [...tempTest],
    }
    setBrowseTag([...tempTest])
    setTest(flattenTree(qqq))
    return _tagType
  }

  const onSetTable = (tags: any) => {
    let _columns = [
      {
        header: 'Tag Code',
        accessorFn: (row) => row.code,
        id: 'code',
        cell: (info) => (
          <div className='link' onClick={() => handleModalTag(info.row.original.tag)}>
            {info.row.original.code}
          </div>
        ),
      },
      {
        header: 'Tag Description',
        accessorFn: (row) => row.name,
        id: 'name',
        cell: (info) => <div>{info.row.original.name}</div>,
      },
      {
        header: 'Status',
        accessorFn: (row) => row.status,
        id: 'status',
        cell: (info) => <div>{info.row.original.status}</div>,
      },
      {
        header: 'Action By',
        accessorFn: (row) => row.updatedBy,
        id: 'updatedBy',
        cell: (info) => <div>{info.row.original.updatedBy}</div>,
      },
      {
        header: 'Action At',
        accessorFn: (row) => row.updatedAt,
        id: 'updatedAt',
        cell: (info) => <div>{formatDate(info.row.original.updatedAt)}</div>,
      },
      {
        header: 'Action',
        id: 'action',
        cell: (info) => (
          <div className='d-flex justify-content-center'>
            <>
              <Button
                className='btn btn-icon btn-primary btn-sm me-1'
                onClick={() => onOpenLog(info.row.original)}
              >
                <i className='fs-6 bi bi-clipboard2-pulse-fill'></i>
              </Button>
            </>
          </div>
        ),
      },
    ]
    // แสดง tag 4 ตัวแรกสุด
    // for (let i in tags[0].attributeGroups) {
    //   if (i == '4') {
    //     break
    //   }
    //   _columns.push({
    //     header: `${tags[0].attributeGroups[i]?.name} ${tags[0].attributeGroups[i].attributes[0].attributeTypeName}`,
    //     accessorFn: (row) => row[`value${i}`],
    //     id: i,
    //     cell: (info) => info.getValue(),
    //   })
    // }
    let temp = [] as any
    for (let i in tags) {
      temp.push({
        name: tags[i].name,
        code: tags[i].code,
        status: tags[i].status.name,
        updatedBy: tags[i].updatedBy,
        updatedAt: tags[i].updatedAt,
        tag: {...tags[i]},
      })
      for (let j in tags[0].attributeGroups) {
        temp[i][`value${j}`] = tags[i].attributeGroups[j].attributes[0].value || null
      }
    }
    setTags([...temp])
    setColumns(_columns)
  }

  const onOpenLog = (value?: any) => {
    setLogId(value.tag.id)
    setModalLogShow(true)
  }

  const handleModalTag = (tag: any) => {
    let temp = [...tag.attributeGroups]

    for (let i in temp) {
      temp[i].isOpen = false
    }
    setTagSelected(tag)
    setModalAttribute([...temp])
    console.log('tag', tag)
    console.log('temp', temp)
    setModalShow(true)
  }

  function getValueByKeyString(data, keyString) {
    // Parse the key string into property names and indices
    var properties = keyString.match(/(?:\['([^']+)'\])|(\[\d+\])/g)
    var value = data

    // Access the value using the parsed properties
    properties.forEach(function (prop) {
      if (prop.startsWith("['")) {
        var propName = prop.substring(2, prop.length - 2)
        value = value[propName]
      } else {
        var index = parseInt(prop.match(/\d+/)[0])
        value = value[index]
      }
    })

    return value
  }
  const handleClose = () => {
    setModalShow(false)
  }
  useEffect(() => {
    if (!formikFilter?.values?.isActive) return
  }, [formikFilter.values.isActive])

  const onReset = () => {
    formikFilter.resetForm()
    setTags(undefined)
    setTest(undefined)
    if (isUser) {
      initUser()
      formikFilter.submitForm()
    }
  }

  const onExport = async (tagSelected: any) => {
    const exportReportService = new ExportEngineeringService()
    const _export = await exportReportService.request(tagSelected.id)
    const buffer = new Uint8Array(_export.data.data)
    exportFile(buffer, `${tagSelected.code}_${tagSelected.name}.xlsx`, 'buffer')
  }

  return (
    <>
      <Card>
        <Card.Body>
          <h1 className='mb-5'>{'AIMS-TAG > Browse Tag'}</h1>
          <Row>
            <Col xs={12} sm={6} md={3}>
              <Select
                required
                isCompany
                formik={formikFilter}
                name={'companyId'}
                label='Company'
                option={user?.companies || []}
                keyLabel='name'
                keyValue='id'
                disabled={isUser}
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Select
                formik={formikFilter}
                name={'plantId'}
                label='Plant'
                option={isUser ? myCompany?.plants || [] : plants || []}
                keyLabel='name'
                keyValue='id'
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Select
                formik={formikFilter}
                name={'disciplineId'}
                label='Discipline'
                option={disciplines || []}
                keyLabel='name'
                keyValue='id'
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Multiselect
                formik={formikFilter}
                name='tagTypeIds'
                label='Tag Type'
                option={tagTypesList || []}
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Multiselect
                formik={formikFilter}
                name='attributeGroupIds'
                label='Attribute Group'
                option={attribute || []}
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <TextField
                formik={formikFilter}
                name={'tagNumber'}
                label='Tag Number'
                noCheckText={true}
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <TextField
                formik={formikFilter}
                name={'tagDescription'}
                label='Tag Description'
                noCheckText={true}
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <TextField
                formik={formikFilter}
                name={'attributeValue'}
                label='Attribute Value'
                noCheckText={true}
              />
            </Col>
            <Col xs={12} className='center justify-end mb-3'>
              <ButtonComp
                variant='secondary'
                onClick={() => onReset()}
                doing={formikFilter.isSubmitting}
                icon='bi bi-arrow-clockwise'
              >
                Reset
              </ButtonComp>
              <ButtonComp
                variant='primary'
                onClick={() => formikFilter.submitForm()}
                doing={formikFilter.isSubmitting}
                icon='bi bi-search'
              >
                Search
              </ButtonComp>
            </Col>
          </Row>
          {formikFilter.isSubmitting ? (
            <>
              <p className='placeholder-glow mt-3'>
                <span className='placeholder bg-secondary col-12' style={{height: 100}}></span>
              </p>
            </>
          ) : (
            <Row className='mt-3'>
              <Col xs={12} sm={6} md={4} style={{border: '1px solid #dbdfe9'}}>
                <div className='directory'>
                  {test && (
                    <TreeView
                      onNodeSelect={(e) => ontest(e)}
                      data={test}
                      aria-label='directory tree'
                      defaultExpandedIds={defaultExpandedIds}
                      defaultSelectedIds={defaultSelectedIds}
                      nodeRenderer={({element, isBranch, isExpanded, getNodeProps, level}) => (
                        <div
                          {...getNodeProps()}
                          style={{
                            fontSize: 16,
                            paddingLeft: 20 * (level - 1),
                            paddingTop: 4,
                            paddingBottom: 4,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {isBranch || element?.metadata?.hasChildren ? (
                            <FolderIcon isOpen={isExpanded} />
                          ) : (
                            <FileIcon filename={element.name} level={level} />
                          )}
                          <div className='text-wrap'>{`${element.name} ${
                            // @ts-ignore
                            level === 3 ? `(${element?.metadata?.tags?.length || 0})` : ``
                          }`}</div>
                        </div>
                      )}
                    />
                  )}
                </div>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={8}
                style={{padding: 0, margin: 0, border: '1px solid #dbdfe9'}}
              >
                <TableData
                  data={tags || []}
                  columns={columns}
                  meta={meta}
                  setMeta={setMeta}
                  pageOption={pageOption}
                  setPageOption={setPageOption}
                  isSort={true}
                />
                {/* <TableDataAll /> */}
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>

      <Modal show={modalShow} onHide={handleClose} centered size='lg' backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title id='contained-modal-title-vcenter' className='gap-2'>
            <h2>{tagSelected.code}</h2>
            <h5>{tagSelected.name}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12} className='d-flex justify-end pt-3'>
              <ButtonComp
                variant='success'
                onClick={() => onExport(tagSelected)}
                doing={formikFilter.isSubmitting}
                icon='bi bi-file-earmark-arrow-up'
              >
                Export Engineering Doc.
              </ButtonComp>
            </Col>
            <Col xs={12} sm={6} md={4} className='test'>
              <Form.Group className='mb-3'>
                <Form.Label>Status</Form.Label>
                <Form.Control type='text' disabled value={tagSelected?.status?.name} />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={4} className='test'>
              <Form.Group
                className='mb-3'
                style={{height: '100%', display: 'flex', alignItems: 'center', marginTop: 8}}
              >
                <input
                  id='isDemolished'
                  className='mx-2 checkbox-ad cursor-pointer'
                  type={'checkbox'}
                  checked={tagSelected?.isDemolished}
                  disabled
                />
                <Form.Label htmlFor='isDemolished' className='mt-1 cursor-pointer'>
                  Demolished
                </Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            {modalAttribute.map((item, i) => {
              return (
                <div key={i}>
                  <Row>
                    <Col xs={12} className='mt-3'>
                      <div
                        onClick={() => {
                          modalAttribute[i].isOpen = !modalAttribute[i].isOpen
                          setModalAttribute([...modalAttribute])
                        }}
                        aria-controls='example-collapse-text'
                        aria-expanded={item.isOpen}
                        style={{display: 'flex', justifyContent: 'space-between'}}
                      >
                        <h4>{item.name}</h4>
                        <i
                          className='bi bi-chevron-down'
                          style={{fontSize: 20, paddingRight: 40}}
                        ></i>
                      </div>
                    </Col>
                    <Col>
                      <Collapse in={item.isOpen}>
                        <Row>
                          {item.attributes.map((el, j) => {
                            return (
                              <Col xs={12} sm={6} md={{span: 4, offset: 1}} key={j}>
                                <Form.Label>
                                  {el.uom
                                    ? `${el.attributeTypeName} (${el.uomUnit})`
                                    : el.attributeTypeName}
                                </Form.Label>
                                <Form.Control type={el.type} value={el.value} disabled />
                              </Col>
                            )
                          })}
                        </Row>
                      </Collapse>
                    </Col>
                  </Row>
                  <hr className='mt-3' />
                </div>
              )
            })}
          </Row>
        </Modal.Body>
      </Modal>
      <ModalLog
        modalLogShow={modalLogShow}
        setModalLogShow={setModalLogShow}
        getLog={GetTagLogService}
        logId={logId}
      />
    </>
  )
}

const FolderIcon = ({isOpen}) =>
  isOpen ? (
    <i className='bi bi-chevron-down' style={{fontSize: 10, marginRight: 5}}></i>
  ) : (
    <i className='bi bi-chevron-right' style={{fontSize: 10, marginRight: 5}}></i>
  )

const FileIcon = ({filename, level}) => {
  const extension = filename.slice(filename.lastIndexOf('.') + 1)
  switch (extension) {
    default:
      return (
        <i className='bi bi-circle-fill' style={{fontSize: 8 - (level - 1), marginRight: 5}}></i>
      )
  }
}

export {BrowseTagPage}
